module.exports = __webpack_public_path__ + "static/media/golden-state-warriors.b33d83a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/svg/golden-state-warriors.svg
// module id = 232
// module chunks = 0